module.exports = __webpack_public_path__ + "static/img/loader.05d5f7fa.svg";